import { HUB_ROUTES } from 'shared/consts/routes/hub';
import { MenuAddButton } from 'shared/ui/section-menu';

export function AddButton() {
  return (
    <MenuAddButton
      path={HUB_ROUTES.ADD_HUB}
      requiredRights={[
        {
          controller: 'Hub',
          right: 'Write',
        },
      ]}
    />
  );
}
